import { IComponentOptions } from "angular";
import { ProgressiveMachineDetailConfigurationComponentController } from "./controller";

export const vsComponentName = "progressiveMachineDetailConfigurationComponent";

export const machineDetailConfigurationComponentOptions: IComponentOptions = {
  controller: ProgressiveMachineDetailConfigurationComponentController,
  controllerAs: "progressiveConfigurationComponent",
  template: require("!html-loader!./index.html").default,
  bindings: {
    machine: "<",
    progressiveDefinitionMachines: "<",
    date: "<",
    progressiveReportGroup: "<",
    progressiveDefinitions: "<",
  },
};
